unit ProvinceSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls,
  Vcl.Controls, WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Client;

type
  TfrmProvinceSetup = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebButton1: TButton;
    WebButton2: TButton;
    WebDBEdit1: TDBEdit;
    wcProvince: TXDataWebClient;
    wdsProvince: TXDataWebDataSet;
    wdsProvinceNo: TIntegerField;
    wdsProvinceName: TStringField;
    wdsProvinceCOUNTRYNO: TIntegerField;
    dsProvince: TDataSource;
    procedure WebButton2Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmProvinceSetup: TfrmProvinceSetup;

implementation

{$R *.dfm}
uses
  stfmssystem.connection, share.common;
procedure TfrmProvinceSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmProvinceSetup.WebFormShow(Sender: TObject);
begin
  wdsProvince.Open;
  wdsProvince.Insert;
end;

procedure TfrmProvinceSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  wcProvince := TXDataWebClient.Create(Self);
  wdsProvince := TXDataWebDataSet.Create(Self);
  wdsProvinceNo := TIntegerField.Create(Self);
  wdsProvinceName := TStringField.Create(Self);
  wdsProvinceCOUNTRYNO := TIntegerField.Create(Self);
  dsProvince := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  wcProvince.BeforeLoadDFMValues;
  wdsProvince.BeforeLoadDFMValues;
  wdsProvinceNo.BeforeLoadDFMValues;
  wdsProvinceName.BeforeLoadDFMValues;
  wdsProvinceCOUNTRYNO.BeforeLoadDFMValues;
  dsProvince.BeforeLoadDFMValues;
  try
    Name := 'frmProvinceSetup';
    Width := 420;
    Height := 220;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 420;
    WebPanel1.Height := 220;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 15;
    WebLabel1.Top := 83;
    WebLabel1.Width := 84;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Province Name:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 420;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Province Setup';
    WebPanel2.ChildOrder := 1;
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 160;
    WebPanel3.Width := 420;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 15;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 136;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 15;
    WebDBEdit1.Top := 104;
    WebDBEdit1.Width := 298;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 2;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'Name';
    WebDBEdit1.DataSource := dsProvince;
    wcProvince.SetParentComponent(Self);
    wcProvince.Name := 'wcProvince';
    wcProvince.Connection := dmData.dbConnect;
    wcProvince.Left := 24;
    wcProvince.Top := 17;
    wdsProvince.SetParentComponent(Self);
    wdsProvince.Name := 'wdsProvince';
    wdsProvince.Connection := dmData.dbConnect;
    wdsProvince.Left := 88;
    wdsProvince.Top := 17;
    wdsProvinceNo.SetParentComponent(wdsProvince);
    wdsProvinceNo.Name := 'wdsProvinceNo';
    wdsProvinceNo.FieldName := 'No';
    wdsProvinceName.SetParentComponent(wdsProvince);
    wdsProvinceName.Name := 'wdsProvinceName';
    wdsProvinceName.FieldName := 'Name';
    wdsProvinceCOUNTRYNO.SetParentComponent(wdsProvince);
    wdsProvinceCOUNTRYNO.Name := 'wdsProvinceCOUNTRYNO';
    wdsProvinceCOUNTRYNO.FieldName := 'COUNTRYNO';
    dsProvince.SetParentComponent(Self);
    dsProvince.Name := 'dsProvince';
    dsProvince.DataSet := wdsProvince;
    dsProvince.Left := 152;
    dsProvince.Top := 17;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    wcProvince.AfterLoadDFMValues;
    wdsProvince.AfterLoadDFMValues;
    wdsProvinceNo.AfterLoadDFMValues;
    wdsProvinceName.AfterLoadDFMValues;
    wdsProvinceCOUNTRYNO.AfterLoadDFMValues;
    dsProvince.AfterLoadDFMValues;
  end;
end;

end.